import React from 'react'
import Footer from "../../aboutus/aboutfooter/Aboutfooter"

export default function Terms_page_footer() {
    return (
        <div>
            <Footer />
        </div>
    )
}
